const foreignWorkerGroupQuery = (id, groupId) => {
  return `
  query {
      getForeignWorkerGroupById(id: "${id}") {
        id
        group_id,
        form_id,
        ForeignWorkerGroupFormData {
          new_group_fw_group_name
          new_group_fw_profiles
          new_group_fw_num_profiles
        }
      }

      getForeignWorkerByGroupId(group_id:"${groupId}") {
      id,
      ForeignWorkerFormData {
        new_profile_fw_profile_name,
        new_profile_fw_first,
        new_profile_fw_last,
        new_profile_fw_alien_reg_number,
      }
      }
      }`;
};

export default foreignWorkerGroupQuery;
